import { useIntl } from 'react-intl'
import { News } from '@models/news'
import { LuxReactionCounter } from '@lux/wardrobe-lib'
import { useEffect } from 'react'

const NewsItemReaction = (props: Partial<News>) => {
    const { reactions, totalComments, loadingReactions } = props

    const newsItemReactionClass = 'home-news-item-reaction'

    const intl = useIntl()

    let _reactionPreview = reactions?.types?.slice(0, 3) || []

    return (
        <div className={newsItemReactionClass}>
            <div className={`${newsItemReactionClass}__container`}>
                {reactions?.count > 0 && (
                    <LuxReactionCounter
                        reactionTypes={_reactionPreview}
                        count={reactions.count}
                        countPosition="right"
                        loading={loadingReactions}
                    />
                )}
            </div>
            <div className={`${newsItemReactionClass}__comments-counter text-mini`}>
                {totalComments}{' '}
                {intl.formatMessage({
                    id: 'home.news.comment.counter',
                    defaultMessage: 'Comments',
                })}
            </div>
        </div>
    )
}

export default NewsItemReaction
